import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

export const useLinkToRoot = () => {
  const { currentCommunity } = usePunditUserContext();
  const navigate = useNavigate();
  const isHomePageEnabled = currentCommunity?.home_page_enabled;

  const goToCommunityRootPath = useCallback(
    (post_login_redirect?: string | null) => {
      const postLoginRedirectQueryParam = post_login_redirect
        ? `?post_login_redirect=${post_login_redirect}`
        : "";

      if (isHomePageEnabled) {
        return void navigate({
          to: "/home",
          search: { post_login_redirect },
        });
      }
      // necessary because Rails layout won't refresh when router does
      window.location.href = `/${postLoginRedirectQueryParam}`;
    },
    [navigate, isHomePageEnabled],
  );

  const goToMessagesRootPath = useCallback(() => {
    void navigate({ to: "/messages" });
  }, [navigate]);

  return { goToCommunityRootPath, goToMessagesRootPath };
};
